import { Controller } from "stimulus"

const controllers = new Set;

export default class extends Controller {
  static targets = [ "si", "im", "switchIm", "switchSi" ];

  connect() {
    controllers.add(this)
    this.setDefault();
  }

  disconnect() {
    controllers.delete(this)
  }

  switchActive(disable, activate, disableButton, activateButton) {
    for (let element of disable) {
      element.classList.remove('unit-active');
    }

    for (let element of disableButton) {
      element.classList.remove('unit-switch-active');
    }

    for (let element of activate) {
      element.classList.add('unit-active');
    }

    for (let element of activateButton) {
      element.classList.add('unit-switch-active');
    }
  }

  setDefault() {
    if (window.location.href.includes('/us/')) {
      this.updateIm();
    } else {
      this.updateSi();
    }
  }

  updateIm() {
    this.switchActive(this.siTargets, this.imTargets, this.switchSiTargets, this.switchImTargets);
  }

  updateSi() {
    this.switchActive(this.imTargets, this.siTargets, this.switchImTargets, this.switchSiTargets);
  }

  showIm(event) {
    event.preventDefault();
    controllers.forEach(controller => controller.updateIm());
  }

  showSi(event) {
    event.preventDefault();
    controllers.forEach(controller => controller.updateSi());
  }
}
